import { ChangeDetectionStrategy, ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, Input, ViewChild } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CrudGenericoService } from '@services/crudGenerico/crudGenerico.service';
import { DialogFormComponent } from '../dialog-form/dialog-form.component';
import { SharedModule } from '@modules/shared.module';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { isFalsy } from 'utility-types';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ComponentModule } from '@modules/component.module';
import { ButtonAddComponent } from '../button-add/button-add.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSliderModule } from '@angular/material/slider';
import { MatDividerModule } from '@angular/material/divider';
import { SinDatosParaMostrarComponent } from '../sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { ButtonNewComponent } from '../button-new/button-new.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { AccionesDialog } from '@models/base/identificadores.model';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { ActivatedRoute } from '@angular/router';
import { CasoUsoService } from '@services/casoUso/casoUso.service';
import { CasoUsoDto } from '@models/seguridad/casosUso/casoUsoDto.model';
import { ButtonFilterTableComponent } from '@component/button-filter-table/button-filter-table.component';
import { ButtonFilterTableClearComponent } from '@component/button-filter-table-clear/button-filter-table-clear.component';

@Component({
  selector: 'app-generic-table',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule,ReactiveFormsModule,ButtonNewComponent,MatCardModule,MatIconModule,MatButtonModule, MatDividerModule,NgxSpinnerModule,MatTableModule,MatSliderModule,SinDatosParaMostrarComponent,MatSlideToggleModule,CommonModule,MatMenuModule,MatDialogModule,AppRolesDirective,ButtonFilterTableComponent,ButtonFilterTableClearComponent],
  templateUrl: 'generic-table.component.html',
  styleUrl: './generic-table.component.css',
  //changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GenericTableComponent {

  @Input() nombreEntidadTabla!: string;
  @Input() nombreEntidad!: string;
  @Input() pathApi!: string;
  @Input() titulo!: string;
  data: boolean = false;
  isFullyLoaded: boolean = false; // Nueva variable para controlar la carga completa

  dataSource = new MatTableDataSource<any>();
  checkedFiltroAvanzado: boolean = false
  displayedColumns = ['descripcion','observaciones','accion'];
  casoUso!: CasoUsoDto;

  constructor(
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private crudGenericoService: CrudGenericoService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private casoUsoService: CasoUsoService,
  ) {
    const ruta = this.route.snapshot.params['id'];
    this.getById(parseInt(ruta));
  }

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnInit() {
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return Object.values(data).some(value =>
        value && value.toString().toLowerCase().includes(filter)
      );
    };
  }

  getById(id: number) {
    this.spinner.show('spListado');
    this.isFullyLoaded = false; // Reiniciar estado de carga

    this.casoUsoService.getById(id)
      .subscribe(
        data => {
          this.casoUso = data;
          this.nombreEntidadTabla = data.nombre;
          this.nombreEntidad = data.nombre;
          this.pathApi = data.pathApi;
          this.titulo = data.descripcion;
          this.cdr.detectChanges();

          // Llamar a getAll después de cargar el caso de uso
          this.getAll();
        },
        error => {
          this.spinner.hide('spListado');
          this.isFullyLoaded = true; // Mostrar contenido aunque haya error
          this.snackBar.showError(error, "Error");
          this.cdr.detectChanges();
        }
      );
  }

  getAll() {
    // No mostrar spinner adicional aquí ya que viene del getById
    this.crudGenericoService.getAll(this.pathApi)
      .subscribe(
        data => {
          this.spinner.hide('spListado');
          this.isFullyLoaded = true; // Marcar como completamente cargado

          this.dataSource.data = data;
          this.data = this.dataSource.data.length >= 1 ? true : false;

          this.dataSource.filterPredicate = (data: any, filter: string) => {
            return Object.values(data).some(value =>
              value && value.toString().toLowerCase().includes(filter)
            );
          };

          this.cdr.detectChanges();
        },
        error => {
          this.spinner.hide('spListado');
          this.isFullyLoaded = true; // Mostrar contenido aunque haya error
          this.snackBar.showError(error, "Error");
          this.cdr.detectChanges();
        }
      );
  }

  filtrosAvanzados(event: any) {
    if (event.checked == true)
      this.checkedFiltroAvanzado = true
    else
      this.checkedFiltroAvanzado = false
  }

  aplicarFiltro() {
    // Solo mostrar spinner para recargas, no afectar isFullyLoaded
    this.spinner.show('spListado');
    this.crudGenericoService.getAll(this.pathApi)
      .subscribe(
        data => {
          this.spinner.hide('spListado');
          this.dataSource.data = data;
          this.data = this.dataSource.data.length >= 1 ? true : false;
          this.cdr.detectChanges();
        },
        error => {
          this.spinner.hide('spListado');
          this.snackBar.showError(error, "Error");
        }
      );
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ver(item: any) {
    const dialogRef = this.dialog.open(DialogFormComponent, {
      width: '500px',
      data: { item: { ...item }, esVista: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      // if (result) {
      //   this.crudGenericoService.getById(this.nombreEntidad, result.id).subscribe(() => this.getAll());
      // }
    });
  }

  agregar() {
    const dialogRef = this.dialog.open(DialogFormComponent, {
      width: '500px',
      data: { item: {}, esNuevo: true }
    });

    dialogRef.afterClosed().subscribe(result => {
     if (result.event == AccionesDialog.Agregar) {
        this.spinner.show('spListado')
        this.crudGenericoService.create(this.nombreEntidad, result.data)
          .subscribe(
            data => {
              this.spinner.hide('spListado')
              this.snackBar.showSuccess("Registro creado correctamente.", "Exito");
              this.aplicarFiltro(); // Usar aplicarFiltro en lugar de getAll
            },
            error => {
              this.spinner.hide('spListado')
              this.snackBar.showError(error, "Error");
            });
      }
    });
  }

  editar(item: any) {
    const dialogRef = this.dialog.open(DialogFormComponent, {
      width: '500px',
      data: { item: { ...item }, esEditar: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.event == AccionesDialog.Modificar) {
        this.spinner.show('spListado')
        this.crudGenericoService.update(this.nombreEntidad, result.data)
          .subscribe(
            data => {
              this.spinner.hide('spListado')
              this.snackBar.showSuccess("Registro actualizado correctamente.", "Exito");
              this.aplicarFiltro(); // Usar aplicarFiltro en lugar de getAll
            },
            error => {
              this.spinner.hide('spListado')
              this.snackBar.showError(error, "Error");
            });
      }
    });
  }

  eliminar(item: any) {
    const dialogRef = this.dialog.open(DialogFormComponent, {
      width: '500px',
      data: { item: { ...item }, esEliminar: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.event == AccionesDialog.Eliminar) {
        this.spinner.show('spListado')
        this.crudGenericoService.delete(this.nombreEntidad, result.data.id)
          .subscribe(
            data => {
              this.spinner.hide('spListado')
              this.snackBar.showSuccess("Registro dado de baja correctamente.", "Exito");
              this.aplicarFiltro(); // Usar aplicarFiltro en lugar de getAll
            },
            error => {
              this.spinner.hide('spListado')
              this.snackBar.showError(error, "Error");
            });
      }
    });
  }
}
